import clsx from 'clsx'

export default function QuickExportButton({
  onClick,
  loading = false,
  disabled = false,
  label = 'Quick Export',
  className = '',
  title = 'Quick Export',
  type = 'button',
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-lg bg-[#004bb7] px-5 py-2.5',
        'text-sm font-bold text-white shadow-md shadow-blue-900/10 transition-all',
        'hover:bg-[#003da1] hover:shadow-lg hover:shadow-blue-900/20 active:scale-[0.98]',
        'focus:outline-none focus:ring-2 focus:ring-[#004bb7]/40 focus:ring-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-60 disabled:shadow-none disabled:active:scale-100',
        className
      )}
    >
      {loading ? (
        <>
          <span className="material-symbols-outlined animate-spin text-[18px]">progress_activity</span>
          <span>Exporting...</span>
        </>
      ) : (
        <span>{label}</span>
      )}
    </button>
  )
}
